import { render, staticRenderFns } from "./TrainingProgram.vue?vue&type=template&id=7935317a&"
import script from "./TrainingProgram.vue?vue&type=script&lang=js&"
export * from "./TrainingProgram.vue?vue&type=script&lang=js&"
import style0 from "./TrainingProgram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports